import { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp, FaPlus, FaTimes } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
const SelectSearch = ({
  list = [],
  label = 'Select Option',
  getOptionLabel = (item) => item.label,
  getOptionValue = (item) => item.value,
  getTypeValue = () => {},
  value = '',
  onChange = () => {},
  error = false,
  placeholder = '',
  disabled = false,
  createNewUrl = '', 
  createNewLabel = 'Create New', 
  createState = {}, 
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const selectedItem = list.find((item) => getOptionValue(item) === value);
    setSearchTerm(selectedItem ? getOptionLabel(selectedItem) : '');
  }, [value, list, getOptionLabel, getOptionValue]);

  const filteredList = list.filter((item) => {
    const label = getOptionLabel(item);
    return typeof label === 'string' && label.toLowerCase().includes((searchTerm || '').toLowerCase());
  });

  const handleSelect = (item) => {
    if (disabled) return;
    const val = getOptionValue(item);
    setSearchTerm(getOptionLabel(item));
    onChange(val);
    setShowOptions(false);
  };

  const handleClear = () => {
    if (disabled) return;
    setSearchTerm('');
    onChange('');
    setShowOptions(false);
  };

  const handleCreateNew = () => {
    if (disabled || !createNewUrl) return;
    navigate(createNewUrl, { state: createState });
      return;
  };

  const toggleOptions = () => {
    if (!disabled) {
      setShowOptions(!showOptions);
      setIsFocused(!showOptions);
    }
  };

  const createNewStyle = {
    fontSize: '0.75rem',
    padding: '0.4rem 1rem',
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#FF8D5C',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#fff',
    fontWeight: '600',
    textTransform: 'none',
  };

  return (
    <div className="custom-date-wrapper">
      <div className="position-relative">
        <input
          type="text"
          className={`form-control custom-date-input ${error ? 'errorborder' : ''}`}
          id="searchSelectInput"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => {
            if (!disabled) {
              setSearchTerm(e.target.value);
              getTypeValue(e.target.value);
              setShowOptions(true);
            }
          }}
          onFocus={() => {
            if (!disabled) {
              setShowOptions(true);
              setIsFocused(true);
            }
            else {
              setShowOptions(false);
              setIsFocused(false);
            }
          }}
          onBlur={() => {
            if (!disabled) {
              setTimeout(() => {
                setShowOptions(false);
                setIsFocused(false);
              }, 300);
            }
          }}
          style={{
            fontSize: '0.8rem',
            padding: '0.8rem 2rem 0.4rem 0.8rem',
            height: '30px',
            border: error ? '1px solid red' : '1px solid #ced4da',
            backgroundColor: disabled ? '#f8f6f6' : 'white',
            cursor: disabled ? 'not-allowed' : 'text',
          }}
          autoComplete="off"
          readOnly={disabled}
        />

        <label
          className={`custom-date-label ${isFocused || searchTerm !== '' ? 'active-tab' : ''} ${disabled ? "bg-disabled" : ""} `}
          htmlFor="searchSelectInput"
        >
          {label}
        </label>


         {!disabled && (
          <div 
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            {searchTerm && (
              <FaTimes 
                size={10} 
                onClick={handleClear}
                style={{
                  cursor: 'pointer',
                  color: '#6e7174',
                  position:'relative',
                  top:'1.5px'
                }}
              />
            )}
            <div 
              style={{
                cursor: 'pointer',
                color: '#6e7174',
              }}
              onClick={toggleOptions}
            >
              {showOptions ? <FaChevronUp size={11} /> : <FaChevronDown size={11} />}
            </div>
          </div>
        )}


        {!disabled && (
          <div 
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#6e7174',
            }}
            onClick={toggleOptions}
          >
            {showOptions ? <FaChevronUp size={11} /> : <FaChevronDown size={11} />}
          </div>
        )}
      </div>

      {!disabled && showOptions && (
        <ul 
          className="dropdown-menu show w-100 mt-1"
          style={{
            position: 'absolute',
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto',
            border: '1px solid rgba(0,0,0,.15)',
            borderRadius: '0.25rem',
            boxShadow: '0 0.5rem 1rem rgba(0,0,0,.15)',
            left:0,
          }}
        >
          {createNewUrl && (
            <li>
              <button
                className="dropdown-item-custom"
                type="button"
                onClick={handleCreateNew}
                style={createNewStyle}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#e67647')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#FF8D5C')}
              >
                <FaPlus size={10} />
                {createNewLabel}
              </button>
            </li>
          )}

          {filteredList.length > 0 ? (
            filteredList.map((item, index) => (
              <li key={index}>
                <button
                  className="dropdown-item-custom"
                  type="button"
                  onClick={() => handleSelect(item)}
                  style={{ 
                    fontSize: '0.8rem',
                    padding: '0.25rem 1rem',
                    width: '100%',
                    textAlign: 'left',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  {getOptionLabel(item)}
                </button>
              </li>
            ))
          ) : (
            <li 
              className="dropdown-item text-muted" 
              style={{ 
                fontSize: '0.8rem',
                padding: '0.25rem 1rem',
              }}
            >
              No results found
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectSearch;
